import { Component, isDevMode, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TITLE } from './app-config';
import { NavRoute } from './models/nav.route';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public title = TITLE;
  public routes?: readonly NavRoute[];
  public redAlert = isDevMode();
  
  constructor(titleService:Title) {
    titleService.setTitle(this.title);
  }
  
}